module.exports = __webpack_public_path__ + "static/media/tata-steel-logo.fa6d382b.svg";